import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BrowserModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Adal5Service, Adal5HTTPService } from 'adal-angular5';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DownloadService as DownloadService } from './service/download.service';
import { EmailService as EmailService } from './service/email.service';
import { AdobeScriptService as AdobeScriptService } from './service/adobe-script.service';
import { GlobalsService as GlobalsService } from './service/global.service';
import {GestureConfig, MatSliderModule} from '@angular/material';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

export function tokenGetter() {
  return localStorage.getItem('token');
}

@NgModule({
    imports: [
      CommonModule,
      BrowserModule,
      BrowserAnimationsModule,
      HttpClientModule,
      NgbModule,
      JwtModule.forRoot({
        config: {
          tokenGetter: tokenGetter
        }
      }),
      AppRoutingModule
    ],
    declarations: [AppComponent],
    providers: [
      DownloadService,
      EmailService,
      Adal5Service,
      { provide: Adal5HTTPService, useFactory: Adal5HTTPService.factory, deps: [HttpClient, Adal5Service]  },
      { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
      AdobeScriptService,
      GlobalsService
    ],
    bootstrap: [AppComponent]
})

export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts